<template>
  <div class="tree__root" >
    <template v-for="tree in treeItems" >
      <tree-node
        :key="tree.manualId"
        :tree-item="tree"
        :tree-depth="1"
        :container-classes="containerClasses"
      >
        <template #internal="{ node, depth, expanded, toggle }">
          <slot
            name="internal"
            :node="node"
            :depth="depth"
            :expanded="expanded"
            :toggle="toggle"
          ></slot>
        </template>
        <template #leaf="{ node, depth }">
          <slot name="leaf" :node="node" :depth="depth"></slot>
        </template>
      </tree-node>
    </template>
  </div>
</template>

<script>
import TreeNode from "@/views/newManual/TreeMenuSlot/TreeNode";
import TreeBase from "@/views/newManual/TreeMenuSlot/TreeBase";

export default {
  name: 'Tree',
  components: { TreeNode },
  extends: TreeBase,
  provide() {
    // root 객체의 각 요소에 반응성을 주기 위해서 defineProperty 를 이용해서 get 을 vue 의 반응성 있는 변수를 반환하도록 재정의 합니다.
    const root = {}
    // autoIndent
    Object.defineProperty(root, 'autoIndent', {
      enumerable: true,
      get: () => this.autoIndent,
    })
    // autoIndentWidth
    Object.defineProperty(root, 'autoIndentWidth', {
      enumerable: true,
      get: () => this.autoIndentWidth,
    })
    // root 객체 반환
    return { root }
  },

  props: {
    /**
     * 트리 아이템 콜렉션입니다.
     */
    treeItems: {
      type: Array,
      default: () => [],
    },

    /**
     * 여러 트리를 확장 상태로 전환할 수 있는지 여부입니다.
     */
    multipleExpandable: { type: Boolean, default: false },

    /**
     * 노드 깊이에 따라서 자동으로 좌측 공간을 확보합니다.
     */
    autoIndent: { type: Boolean, default: true },
    /**
     * 노드 깊이에 따라서 자동으로 좌측 공간이 확보될 때의 너비입니다. in px.
     */
    autoIndentWidth: { type: Number, default: 20 },
    containerClasses: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    /**
     * 모든 내부 노드를 접습니다.
     */
    collapseAll() {
      this.collapse()
    },

    /**
     * 모든 내부 노드를 확장합니다.
     */
    expandAll() {
      this.expand()
    },
  },
}
</script>

<style lang="scss" scoped>
.tree__root {
  transition: all;
  transition-duration: 0.3s;
}
</style>
